import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import hungarian from './shared/locales/hu.json';
import english from './shared/locales/en.json';

const resources = {
  en: {
    translation: english,
  },
  hu: {
    translation: hungarian,
  },
};

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources,
  fallbackLng: 'en',
});
